<div class="container-seat-map">
  <div class="column-left"></div>
  <div class="column-seats">
    <div class="container-lettes">
      <div class="box-letter" [class.space]="!letter" *ngFor="let letter of Letters">
        <div *ngIf="letter" class="box-letter"></div>
      </div>
    </div>
    <div class="container-title">
      <div class="line-left">
        <div class="line"></div>
      </div>
      <div class="title-column">
        <div class="box-title"></div>
      </div>
      <div class="line-right">
        <div class="line"></div>
      </div>
    </div>
    <div class="container-seats" *ngFor="let rowData of [].constructor(16)">
      <ng-container *ngFor="let seat of Letters">
        <div class="box-seat" *ngIf="seat;else boxSeatSpace">
        </div>
        <ng-template #boxSeatSpace>
          <div class="box-space-aisle">
            <span>
            </span>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
  <div class="column-right"></div>
</div>